// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3IJrn","input":"style_input__hz3P4","form":"style_form__1iR0R","column":"style_column__awLwE","warning":"style_warning__2yl73"};